import { View } from 'react-native';
import { Checkbox } from '@socrait/react';

import { type IncludeKey } from '~/services/studentData';
import { type IncludeOptions } from '~/store/studentData/studentDataStore';

import { INCLUDE_LABELS } from './sharedFilters';
import { filterPanelStyles } from './sharedStyles';

type IncludeCheckboxesProps = {
  include: IncludeOptions;
  onChange: (key: IncludeKey, checked: boolean) => void;
};

export function IncludeCheckboxes({ include, onChange }: IncludeCheckboxesProps) {
  return (
    <View style={[filterPanelStyles.checkboxGroup, filterPanelStyles.sectionContent]}>
      {(Object.keys(INCLUDE_LABELS) as IncludeKey[]).map((key) => (
        <Checkbox
          key={key}
          label={INCLUDE_LABELS[key]}
          isChecked={include[key]}
          onToggle={(checked) => onChange(key, checked)}
          labelStyle={filterPanelStyles.optionLabel}
        />
      ))}
    </View>
  );
}
